/** Data URL for ShapeX toolbar placement — matches default shape accent (#ff4d4f). */
export const SHAPE_X_MARKER_IMAGE_DATA_URL =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">' +
      '<line x1="8" y1="8" x2="40" y2="40" stroke="#ff4d4f" stroke-width="4" stroke-linecap="round"/>' +
      '<line x1="40" y1="8" x2="8" y2="40" stroke="#ff4d4f" stroke-width="4" stroke-linecap="round"/>' +
      '</svg>'
  );

/** Html img size for billboard ShapeX (larger than default 24px marker pins). */
export const SHAPE_X_MARKER_IMG_PX = 44;
